module.exports = __webpack_public_path__ + "img/fe_backdrop_hannibal.5d629c49.png";